export default __webpack_public_path__ + "static/media/doc-arrows.5768106a.svg";